import { render, staticRenderFns } from "./AvisoPago.vue?vue&type=template&id=2499b1c2&scoped=true"
import script from "./AvisoPago.vue?vue&type=script&lang=js"
export * from "./AvisoPago.vue?vue&type=script&lang=js"
import style0 from "./AvisoPago.vue?vue&type=style&index=0&id=2499b1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2499b1c2",
  null
  
)

export default component.exports